/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Tooltip } from '@/primitives/Tooltip';

import { Endpoint, TagGroup } from './types';

interface EndpointListProps {
  tags: TagGroup[];
  selected: Endpoint | null;
  onSelect: (endpoint: Endpoint) => void;
}

export function EndpointList({ tags, selected, onSelect }: EndpointListProps) {
  return (
    <>
      {tags.map((tag) => (
        <div key={tag.name} className="apiref-tag">
          <span className="apiref-tag-label">{tag.name}</span>
          {tag.endpoints.map((ep) => {
            const isSelected = selected?.method === ep.method && selected?.path === ep.path;
            return (
              <Tooltip key={`${ep.method}-${ep.path}`} title={ep.description} placement="right" mouseEnterDelay={0.4}>
                <button
                  type="button"
                  className={`apiref-item ${isSelected ? 'is-selected' : ''}`}
                  onClick={() => onSelect(ep)}
                >
                  <span className={`apiref-item-method method-${ep.method}`}>{ep.method.toUpperCase()}</span>
                  <span className="apiref-item-path">{ep.path}</span>
                </button>
              </Tooltip>
            );
          })}
        </div>
      ))}
    </>
  );
}
